import React, { useEffect, useState, useCallback } from 'react';
import { useIntl } from 'umi';
// import DataTable from '@/containers/data_table_ml/DataTable';
import { Box } from '@material-ui/core';
import DataTableNativeML from '@/components/DataTableNativeML';
import { useDispatch, useSelector } from 'dva';
import dayjs from 'dayjs';
// import styles from './gradeChange.less?modules';

const GradeChange = (props) => {
  //关于国际化
  const intl = useIntl();
  const { formatMessage } = intl;
  const { params = {} } = props || {};
  const { id } = params || {};
  // const [limit, setLimit] = useState(10);
  // const [page, setPage] = useState(1);
  const [pageData, setPageData] = useState({
    pageSize: 10,
    pageNum: 1,
  });
  const columns = [
    {
      title: `${formatMessage({ id: 'cm.member.detail.c04.lbl01' })}(生效时间)`,
      id: 'changeDate',
      key: 'changeDate',
      width: 200,
      // width: 392,
      align: 'center',
      render: ({ changeDate: text }) =>
        dayjs(text).format('YYYY-MM-DD HH:mm:ss'),
    },
    {
      title: '等级过期时间',
      id: 'expireDate',
      key: 'expireDate',
      width: 180,
      // width: 392,
      align: 'center',
    },
    {
      title: formatMessage({ id: 'cm.member.detail.c04.lbl02' }),
      id: 'levelOld',
      key: 'levelOld',
      width: 180,
      align: 'center',
      render: ({ levelOld }) => levelOld || '-',
    },
    {
      title: formatMessage({ id: 'cm.member.detail.c04.lbl03' }),
      id: 'levelNew',
      key: 'levelNew',
      width: 180,
      align: 'center',
      // width: 300,
    },
    // {
    //   title: '渠道',
    //   id: 'channel',
    //   key: 'channel',
    // },
    {
      title: formatMessage({ id: 'cm.member.detail.c04.lbl04' }),
      align: 'center',
      width: 220,
      key: 'remark',
      id: 'remark',
    },
    {
      title: formatMessage({ id: 'cm.member.detail.c04.lbl05' }),
      align: 'center',
      width: 180,
      key: 'createBy',
      id: 'createBy',
      render: ({ createBy }) => (createBy ? createBy : '--'),
    },
  ];

  const dispatch = useDispatch();

  const loadingEffect = useSelector((state) => state.loading);
  const loading = loadingEffect.effects['ml/getGradeChange'];
  const gradeData = useSelector((state) => state.ml.getGradeChange);
  const { total, data: dataList } = gradeData || {};
  // 发起请求
  const setUseCallback = useCallback(() => {
    if (id) {
      dispatch({
        type: 'ml/getGradeChange',
        payload: {
          values: {
            limit: pageData.pageSize,
            page: pageData.pageNum,
            member_id: id,
          },
        },
      });
    }
  }, [dispatch, pageData.pageNum, pageData.pageSize, id]);
  useEffect(() => {
    setUseCallback();
  }, [setUseCallback]);
  return (
    <Box style={{ height: '100%' }}>
      <DataTableNativeML
        loading={loading}
        paging={true}
        total={total}
        columns={columns}
        page={{
          ...pageData,
          total: total,
        }}
        changePage={(pageObj) => {
          setPageData(pageObj);
        }}
        data={dataList}
        columnKey="id"
      ></DataTableNativeML>
    </Box>
  );
};
export default GradeChange;
